var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent"},[_c('div',{staticClass:"divTitle",style:({ color: _vm.titleColor })},[_vm._v(_vm._s(_vm.title))]),(_vm.subTitle)?_c('div',{staticClass:"divSubTitle",style:({ color: _vm.subTitleColor })},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }